export const ProviderConnectionTypes = {
  clientTo3PL: 'client_3pl',
  marketplaceToVendor: 'marketplace_vendor',
};
